<template>
    <el-input-number
        ref="inputNumberRef"
        v-if="permissionsShow"
        v-model="currentValue"
        :placeholder="$t(placeholder)"
        :min="min"
        :max="max"
        :size="size"
        :step="step"
        :precision="precision"
        :disabled="disabled"
        :controls="controls"
        :step-strictly="stepStrictly"
        :controls-position="controlsPosition"
        :style="{ width: width + 'px' }"
        :label="label"
        @change="_change"
        @blur="_blur"
        @focus="_focus"
        @keydown.native="handleClick"
    >
    </el-input-number>
</template>
<script>
export default {
    props: {
        // 绑定值
        value: {},
        // 设置计数器允许的最大值
        max: {
            type: Number,
            default: Infinity
        },
        // 设置计数器允许的最小值
        min: {
            type: Number,
            default: -Infinity
        },
        // 计数器步长 默认为1
        step: {
            type: Number,
            default: function() {
                return 1;
            }
        },
        //是否只能输入 step 的倍数
        stepStrictly: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 数值精度 precision 的值必须是一个非负整数，并且不能小于 step 的小数位数。
        precision: {
            type: Number,
            validator(val) {
                return val >= 0 && val === parseInt(val, 10);
            }
        },
        // 计数器尺寸  可选值large, small
        size: String,
        // 是否禁用计数器
        disabled: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 是否使用控制按钮
        controls: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 控制按钮位置
        controlsPosition: {
            type: String
        },
        // 输入框默认 placeholder
        placeholder: {
            type: String,
            default: function() {
                return 'component.PLEASE_INPUT';
            }
        },
        /* 宽度设置 */
        width: {
            type: [Number, String],
            default: function() {
                return 200;
            }
        },
        /* 输入框关联的label文字 */
        label: String,
        /* 所有权限信息 */
        permissions: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 角色信息 */
        roles: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 权限之一 */
        oneOfPermissions: {
            type: Array,
            default: function() {
                return [];
            }
        }
    },
    watch: {
        value(newVal) {
            this.currentValue = newVal;
            this._change(newVal);
        }
    },
    data() {
        return {
            currentValue: Object,
            isNull: false,
            /* 是否满足显示权限 */
            permissionsShow: true
        };
    },
    created() {
        /* 权限数据处理 */
        if (this.permissions.length > 0 || this.oneOfPermissions.length > 0 || this.roles.length > 0) {
            this.permissionsShow = this.dealPermissions(this.permissions, this.roles, this.oneOfPermissions);
        }
        // /* 判断初始值为空 */
        if (this.$util.isEmpty(this.value)) {
            this.currentValue = undefined;
        } else {
            this.currentValue = this.value;
        }
    },
    methods: {
        handleClick(pressKey) {
            /* 获取键盘输入按键信息 */
            let key = pressKey.key;
            let length = key.length;
            if (length <= 1) {
                /* 输入信息非数字时不显示 */
                let pushKey = key.replace(/[^\d]/g, '');
                if (!pushKey) {
                    pressKey.preventDefault();
                }
            }
        },
        _change(value) {
            /* 实现数据向父组件的的实时传输 */
            this.$emit('input', value);
            /* 在值改变时触发,父组件可进行注册change方法 */
            this.$emit('change', value);
        },
        /* 组件失去焦点时触发，父组件可进行blur方法注册 */
        _blur(event) {
            this.$emit('blur', event);
        },
        /* 组件获得焦点时触发，父组件可进行focus方法注册 */
        _focus(event) {
            this.$emit('focus', event);
        },
        focus() {
            this.$refs.inputNumberRef.focus();
        },
        /* 选中 input 中的文字 */
        select() {
            this.$refs.inputNumberRef.select();
        }
    }
};
</script>
